import React from "react";
import './styles.css'

const CommonInputRow = ({ children, className }) => {
    return (
        <div className={`common-input-row ${className}`}>{children}</div>
    )
}

export default CommonInputRow